const MobileRedirect = () => 'Redirecting.....';

export default MobileRedirect;
